import { clearVisitStore } from './AnalyticSvc';
import timeoutClear from './timeoutClear';
import detectUserActivity from './detectUserActivity';

const timeout = options.isProduction ? 2 * 60 * 60 * 1000 : 3 * 60 * 1000;

const analyticTimeoutClear = (clear: () => void) => () =>
    timeoutClear('analytic', timeout)(clear);
const runTimeout = _.compose(
    detectUserActivity,
    analyticTimeoutClear
);

let clearAnalyticStorage: () => void = _.noop;

export default () => {
    clearAnalyticStorage();
    clearAnalyticStorage = runTimeout(clearVisitStore);
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/analyticSupport.ts